export const t = { "en": { "breezeSetupDealAutomations": { "setupPrompt": "Help me set up deal automations." } } };
export const d = [];